<template>
  <section class="py-2 text-right container d-md-block d-none">
    <router-link to="/">
    <span class="ml-2 text-color-theme weight-light fontsize-mini">خانه</span>
    
    </router-link>
    <div v-for="(item , index) in items" :key="index" class="d-inline-block">
      <span class="text-color-theme weight-light">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.5 8L13 11.5L16.5 15" stroke="#30504f" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M10.5 8L7 11.5L10.5 15" stroke="#30504f" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      <span v-if="index!=0" class="mr-2 text-color-theme weight-light fontsize-mini"> {{ item }} </span>
     <router-link v-else :to="last" >
        <span class="mr-2 text-color-theme weight-light fontsize-mini"> {{ item }} </span>
       </router-link>
    </div>



  </section>
</template>

<script>
export default {
  name: "PagesPath",
  props:{
    items:Array,last:String
  },
}
</script>

<style scoped>

</style>